import { render, staticRenderFns } from "./AddIndirectTax.vue?vue&type=template&id=22073b59"
import script from "./AddIndirectTax.vue?vue&type=script&lang=js"
export * from "./AddIndirectTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports